<template>
    <div class="static-heaer" style="background: radial-gradient(circle, rgba(87,109,228,1) 0%, rgba(56,56,173,1) 100%)">
        <div class="texto">
            <div class="b-title" style="font-size: 3.2rem; font-weight: 700; color: yellow">Curso Internacional "Telemedicina a un CLICK!"<br>
            </div>
            <div class="b-title">La cuarta revolución —o 4RI— ha traído sorprendentes avances para el sector salud.
                La tecnología al alcance de cada vez más personas, mejoran notablemente el acceso a los servicios,
                pero, al mismo tiempo, implican importantes retos para la formación y ética a los profesionales de salud,
                y la pandemia lo ha puesto de manifiesto, con un aumento del 2575% en consultas de telemedicina en el mundo
            </div>
            <div style="display: flex; flex-direction: row; justify-content: center; flex-wrap: wrap; padding: 15px 0">
                <img src="/image/brand/tmcb.png" width="300px" height="auto"/>
                <img src="/image/brand/unitec.png" width="300px"  height="auto"/>
            </div>
            <div style="display: flex; justify-content: center; margin-top: 10px; text-align: center; flex-direction: column; align-items: center">

                <router-link tag="div" to="/pro/Telemedicina/oferta" class="boton_a">INSCRIBETE AHORA!</router-link>
            </div>
        </div>
        <div class="image">
            <img src="/image/resource/omidres2.png" class="image_o"/>
        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import formLanding from './../resources/formLandingEvent.vue'
    export default {
        name: '',
        components: {
            formLanding
        },
        created(){

        },
        data(){
            return {
                image:'https://firebasestorage.googleapis.com/v0/b/omidressite.appspot.com/o/proyects%2Fomidres-site%2Fslider%2Fheader%20web-01.jpg?alt=media&token=c8b863c0-d131-4856-84b4-0cc082dac9fa',
                showModal: false
            }
        },
        computed: {
            ...mapState,


        },
        methods:{

        }

    }
</script>
<style scoped>
    .boton_a{
        width: 290px;
        height: 90px;
        background-color: #FF4500;
        border: solid 1px white;
        border-radius: 10px;
        color: white;
        font-weight: 700;
        padding-top: 10px;
        cursor: pointer;
        font-size: 2rem;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .static-heaer{
        display: flex;
        flex-direction: row;
        justify-content: space-around;

        min-height: 100vh;
        background-size: cover;
        background-repeat: no-repeat;
        overflow-x : hidden;
        overflow-y : hidden
    }
    .image{
        width: 45%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-end;
    }
    .image_o{
        width: 60%;
    }
    .texto{
        width: 55%;
        color: white;
        display: flex;
        flex-direction: column;
        font-size: 3rem;
        align-content: flex-start;
        justify-content: flex-start;
        margin-top: 120px;
        margin-left: 100px;
        text-shadow: 2px 2px 2px #0F4F84;
        font-family: 'Gayathri', sans-serif;
        padding-bottom: 20px;
    }
    .b-title{
        font-size: 2rem;
        line-height: 2.8rem;
        font-weight: 500;
        text-align: center;
    }
    .glucometro{
        margin-left: 160px;
        animation-duration: 3s
    }
    .img_g{
        width: 50%;
    }
    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }
    @media (min-width: 768px) and (max-width: 1024px) {

    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 481px) and (max-width: 767px) {

    }

    @media (min-width: 10px) and (max-width: 480px) {
        .static-heaer{
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: auto;
            overflow-x : hidden;
            overflow-y : hidden
        }
        .texto{
            text-align: center;
            min-width: 320px;
            color: white;
            display: flex;
            flex-direction: column;
            margin-left: 5px;
            justify-content: flex-start;
            text-shadow: 2px 2px 2px #0F4F84;
            font-family: 'Gayathri', sans-serif;

        }
        .image{
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
        }

        .b-title{
            font-size: 1.5rem;
            line-height: 2.5rem;
            font-weight: 500;
            min-width: 320px
        }

    }
</style>